import * as React from "react";
import { AppRoute, webTitle } from "./routes";
import { createStackNavigator } from "@react-navigation/stack";
import { createDrawerNavigator } from "@react-navigation/drawer";
import {
  Home,
  MyFiles,
  Friends,
  Favorites,
  FriendProfile,
  AuthCallback,
} from "../scenes";
import DrawerButton from "../components/drawer-button";
import AppHeaderRight from "../components/app-header-right";

type FriendProfileParams = {
  userId: number;
};

export type AppDrawerParams = {
  [AppRoute.HOME]: undefined;
  [AppRoute.MYFILES]: undefined;
  [AppRoute.FAVORITES]: undefined;
  [AppRoute.AUTH_CALLBACK]: undefined;
};

const Drawer = createDrawerNavigator<AppDrawerParams>();

export default function AppNavigator() {
  const drawerScreenOptions = {
    headerShown: true,
    headerLeft: () => <DrawerButton />,
    headerRight: () => <AppHeaderRight />,
    title: "Bitdrop",
  };

  return (
    <Drawer.Navigator
      initialRouteName={AppRoute.HOME}
      screenOptions={{
        ...drawerScreenOptions,
        drawerStyle: {
          width: 240,
        }
      }}
    >
      <Drawer.Screen 
        name={AppRoute.HOME} 
        component={Home}
        options={{ drawerLabel: "Home" }}
      />
      <Drawer.Screen 
        name={AppRoute.MYFILES} 
        component={MyFiles}
        options={{ drawerLabel: "My Files" }}
      />
      <Drawer.Screen 
        name={AppRoute.FAVORITES} 
        component={Favorites}
        options={{ drawerLabel: "Favorites" }}
      />
      <Drawer.Screen 
        name={AppRoute.AUTH_CALLBACK} 
        component={AuthCallback}
        options={{ 
          drawerLabel: () => null,
          drawerItemStyle: { display: 'none' }
        }}
      />
    </Drawer.Navigator>
  );
}
